import {Button, Modal} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import 'react-medium-image-zoom/dist/styles.css'
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import {FilePond, registerPlugin} from "react-filepond";
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import NsModalHeader from "../../../../components/modal/NsModalHeader";
import Translate from "../../../../components/Translate";
import {
    aggiornaMarcaArchivioApi, aggiungiMarcaArchivioApi, getMarcaArchivioByIdApi,
} from "../../../../services/ArchivioServices";
import {LoaderContext} from "../../../../context/LoaderContext";

// Registrazione plugins
registerPlugin(
    FilePondPluginImagePreview,
    FilePondPluginFileValidateType
);


export default function ModalAddMarcaArchivio({
                                                  idMarca,
                                                  tipoVeicolo,
                                                  show,
                                                  handleClose,
                                                  submitOk
                                              }) {


    const [files, setFiles] = useState([]);
    const [marca, setMarca] = useState('');
    const [marcaOri, setMarcaOri] = useState(null);
    const [idTipoVeicolo, setIdTipoVeicolo] = useState(null);
    const [isSaving, setIsSaving] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    // Reset completo allo stato iniziale
    const resetState = () => {
        setFiles([]);
        setMarca('');
        setIsSaving(false);
    };

    // Funzione per gestire il salvataggio manuale
    const handleSave = async () => {
        if (!marca) {
            alert("La Marca è obbligatoria.");
            return;
        }

        // Mostra feedback di caricamento
        setIsSaving(true);

        const formData = new FormData();
        formData.append('marca', marca.trim());
        formData.append('tipo_veicolo', idTipoVeicolo);

        files.forEach(fileItem => {
            formData.append('files', fileItem.file);
        });

        try {
            var response;

            if (idMarca) {
                // Modifica titolo
                response = await aggiornaMarcaArchivioApi(idMarca, formData);
            } else {
                // Aggiungi titolo
                response = await aggiungiMarcaArchivioApi(formData);
            }

            submitOk(response.data);
            handleClose();
        } catch (error) {
            console.error("Upload failed:", error.response ? error.response.data : error.message);
            // Mostra un messaggio di errore all'utente
            alert("Errore durante il caricamento del file. Riprova.");
        } finally {
            setIsSaving(false);
        }
    };

    async function getMarca() {
        startChiamata();
        const response = await getMarcaArchivioByIdApi(idMarca);
        endChiamata();

        let dati = response.data.data;
        if (dati) {
            setMarca(dati.marca);
            setMarcaOri(dati);
        }
    }

    useEffect(() => {
        resetState();
        if (idMarca && idMarca !== '') {
            getMarca();
        }
    }, [idMarca]);

    useEffect(() => {
        setIdTipoVeicolo(tipoVeicolo);
    }, [tipoVeicolo]);

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size={"xl"}
        >
            <NsModalHeader
                title={(idMarca && idMarca !== '') ? `Modifica marca ${marcaOri && marcaOri.marca}` : 'Aggiungi nuova marca'}/>
            <Modal.Body>
                <div className={"row g-3"}>
                    <div className={"col-md-6"}>
                        <label htmlFor="marca" className="form-label">Marca*:</label>
                        <input
                            id={"marca"}
                            name={"marca"}
                            className={"form-control"}
                            value={marca}
                            onChange={(ev) => setMarca(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="tipo_veicolo" className="form-label">Tipo veicolo*:</label>
                        <select
                            id={"tipo_veicolo"}
                            name={"tipo_veicolo"}
                            className={"form-control"}
                            value={tipoVeicolo}
                            disabled={true}
                        >
                            <option value={'1'}>Auto</option>
                            <option value={'2'}>Moto</option>
                        </select>
                    </div>
                    <div className={"col-md-12 mt-4"}>
                        <label className="form-label">Immagine/logo:</label>
                        <FilePond
                            files={files}
                            onupdatefiles={setFiles}
                            acceptedFileTypes={[
                                "image/png", "image/jpeg", "image/gif", "image/bmp", "image/svg+xml", "image/heic"
                            ]}
                            allowFileTypeValidation={true}
                            fileValidateTypeDetectType={(source, type) =>
                                new Promise((resolve) => {
                                    resolve(type);
                                })
                            }
                            allowMultiple={true}
                            allowRevert={true}
                            allowReorder={true}
                            allowImagePreview={true}
                            imagePreviewMaxHeight={200}
                            name="files"
                            labelIdle={
                                'Trascina qui i tuoi documenti o <span class="filepond--label-action">Cerca</span>'
                            }
                            labelInvalidField={'Il campo contiene file non validi'}
                            labelFileWaitingForSize={'In attesa della dimensione'}
                            labelFileSizeNotAvailable={'Dimensione non disponibile'}
                            labelFileLoading={'Caricamento'}
                            labelFileLoadError={'Errore durante il caricamento'}
                            labelFileProcessing={'Caricamento'}
                            labelFileProcessingComplete={'Caricamento completato'}
                            labelFileProcessingAborted={'Caricamento annullato'}
                            labelFileProcessingError={'Errore durante il caricamento'}
                            labelTapToCancel={'tocca per annullare'}
                            labelTapToRetry={'tocca per riprovare'}
                            labelTapToUndo={'tocca per annullare'}
                            labelButtonRemoveItem={'Rimuovi'}
                            labelButtonAbortItemLoad={'Annulla'}
                            labelButtonRetryItemLoad={'Riprova'}
                            labelButtonAbortItemProcessing={'Annulla'}
                            labelButtonUndoItemProcessing={'Annulla'}
                            labelButtonRetryItemProcessing={'Riprova'}
                            labelButtonProcessItem={'Carica'}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={isSaving}>
                    <Translate>Chiudi</Translate>
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={!idMarca && (isSaving || !marca)}>
                    {isSaving ? 'Salvataggio...' : <Translate>Salva</Translate>}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}